import { Component, OnInit } from '@angular/core';
import { format, isToday } from 'date-fns';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import { CalculaAproximacaoService } from '../service/calcula-aproximacao.service';

@Component({
  selector: 'app-vw-operacao-sese',
  templateUrl: './vw-operacao-sese.component.html',
  styleUrl: './vw-operacao-sese.component.css'
})
export class VwOperacaoSESEComponent implements OnInit {

  subscription: Subscription | undefined;
  items: any[] = [];
  trips: any[] = [];
  rota: any[] = [];
  tripsReturn: any[] = [];
  itemsAntigo: any[] = [];
  fornecedores: any[] = [];
  posicao: any[] = [];
  sortColumn: string = '';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  // query: string = 'items_Operacao_VW';
  query: string = 'PlanilhaVWSESE';
  query2: string = 'Porta_Rastreando_VW';
  query3: string = 'Fornecedores_Karrara_Transport';
  query4: string = 'Carriers';
  query5: string = 'tipos_Veiculos_Karrara';
  data: any;
  editMode!: boolean[];
  informationMode!: boolean[];
  address!: string;
  DataAtual: Date = new Date();
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: ''
  };
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  janela1!: string;
  janela2!: string;
  janela3!: string;
  janela4!: string;
  editJanela1!: string;
  editJanela2!: string;
  editJanela3!: string;
  editJanela4!: string;
  janelaDestino1!: string;
  janelaDestino2!: string;
  janelaDestino3!: string;
  janelaDestino4!: string;
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  carriers!: any[];
  places!: any[];
  transportadora!: string[];
  locais!: string[];
  datePipe: any;
  rastreioAtivo!: boolean;

  progManual: string[] = [
    'PROGRAMAÇÃO VWCO SP'
  ];
  selectedDescription!: string;
  Transportadoras!: string;
  listaTransportadoras!: any[];
  dataInvertida: string = '';
  fornecedores1!: any[];
  fornecedores2!: any[];
  fornecedores3!: any[];
  fornecedores4!: any[];
  fornecedoresDescarga1!: any[];
  fornecedoresDescarga2!: any[];
  fornecedoresDescarga3!: any[];
  fornecedoresDescarga4!: any[];
  tipoVeiculo!: any[];
  listaVeiculo1!: any[];
  datadescarga!: string | null;
  tipoVeiculos: any;
  isLoading: boolean = true;
  nomeContato: string = '';
  telefone: string = '';



  constructor(
    private dynamoDBService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private carregaService: CarregaService,
    private aproximacaoService: CalculaAproximacaoService
  ) {
    this.editMode = [];
    this.informationMode = [];
  }

  async ngOnInit() {

    await this.getItemsFromDynamoDB();
    await this.getFornecedoresFromDynamoDB();
    await this.getPosicaoFromDynamoDB();
    await this.getCarriersFromDynamoDB();
    await this.getTipoVeiculoFromDynamoDB();
    // this.verificaFinalizado()

    // setTimeout(() => {
    await this.armazenarLatitudeEmItems();
    await this.filtra();
    await this.verificaConexaoJanela();
    this.isLoading = false;

    // this.verificaFinalizado()
    // }, 1500);

    // Aguardar 1,5 segundo antes de chamar this.filtra()
    // setTimeout(() => {
    //   this.filtra();
    // }, 1500);


    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      // Chame a função que deseja executar a cada 3 minutos aqui
      await this.getItemsFromDynamoDB();
      // await this.getFornecedoresFromDynamoDB();
      await this.getPosicaoFromDynamoDB();
      // await this.getCarriersFromDynamoDB();
      // await this.getTipoVeiculoFromDynamoDB();

      // setTimeout(() => {
      await this.armazenarLatitudeEmItems();
      // }, 1500);

      // Aguardar 1 segundo antes de chamar this.filtra()
      // setTimeout(() => {
      await this.filtra();
      await this.verificaConexaoJanela();

      this.isLoading = false;

      // }, 1500);
    });
  }

  async update() {
    await this.getItemsFromDynamoDB();
    await this.getFornecedoresFromDynamoDB();
    await this.armazenarLatitudeEmItems();
    await this.filtra();
    await this.verificaConexaoJanela();
    this.isLoading = false;

  }

  // addViagem(item: any): void {

  //   this.item['Janela 1'] = item['Janela 1'];
  //   this.item['Janela 2'] = item['Janela 2'];
  //   this.item['Janela 3'] = item['Janela 3'];
  //   this.item['Janela 4'] = item['Janela 4'];
  //   this.editJanela1 = '';
  //   this.editJanela2 = '';
  //   this.editJanela3 = '';
  //   this.editJanela4 = '';
  //   this.item['JanelaDestino 1'] = item['JanelaDestino 1'];
  //   this.item['JanelaDestino 2'] = item['JanelaDestino 2'];
  //   this.item['JanelaDestino 3'] = item['JanelaDestino 3'];
  //   this.item['JanelaDestino 4'] = item['JanelaDestino 4'];
  //   this.editJanelaDestino1 = '';
  //   this.editJanelaDestino2 = '';
  //   this.editJanelaDestino3 = '';
  //   this.editJanelaDestino4 = '';

  //   if (Array.isArray(this.carriers)) {
  //     this.transportadora = this.carriers.map(carrier => carrier.name);
  //   }

  //   if (Array.isArray(this.places)) {
  //     this.locais = this.places.map(places => places.local);
  //   }

  //   this.item.ID = item.ID
  //   this.item.Transportadora = item.Transportadora;
  //   this.item.Plate = item.Plate;
  //   this.item['Transport Type'] = item['Transport Type'];
  //   this.item['Destino 1'] = item['Destino 1'];
  //   this.item['Destino 2'] = item['Destino 2'];
  //   this.item['Destino 3'] = item['Destino 3'];
  //   this.item['Destino 4'] = item['Destino 4'];
  //   this.item.datadescarga = this.datadescarga;
  //   this.item['Fornecedor 1'] = item['Fornecedor 1'];
  //   this.item['Fornecedor 2'] = item['Fornecedor 2'];
  //   this.item['Fornecedor 3'] = item['Fornecedor 3'];
  //   this.item['Fornecedor 4'] = item['Fornecedor 4'];


  //   if (item.description !== undefined && item.description !== '' && item.description !== null) {
  //     this.progManual.push(item.description);
  //   }

  //   this.item.description = item.description;
  //   this.dialogAddViagem = true;

  //   let dateObject = new Date(item.date);
  //   let day = dateObject.getUTCDate();
  //   let month = dateObject.getUTCMonth() + 1; // Os meses em JavaScript começam em 0, então é necessário adicionar 1
  //   let year = dateObject.getUTCFullYear();
  //   let formattedDate = `${year.toString()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  //   // //console.log('data coleta' + formattedDate); // Output: "30-06-2023"
  //   this.item.date = formattedDate;
  //   // //console.log("date")
  //   // //console.log(formattedDate)

  //   dateObject = new Date(item.datadescarga);
  //   day = dateObject.getUTCDate();
  //   month = dateObject.getUTCMonth() + 1; // Os meses em JavaScript começam em 0, então é necessário adicionar 1
  //   year = dateObject.getUTCFullYear();
  //   formattedDate = `${year.toString()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  //   // //console.log('data entrega' + formattedDate); // Output: "30-06-2023"
  //   this.item.datadescarga = formattedDate;
  //   // //console.log("date descarga")
  //   // //console.log(formattedDate)

  //   this.item['Total Cost'] = item['Total Cost'];
  //   this.item.Volumes = item.Volumes;
  //   this.item['Total Distance'] = item['Total Distance'];
  //   this.item['Weight Loaded'] = item['Weight Loaded'];
  //   this.item.Cubage = item.Cubage;
  //   this.item.itemsLoaded = item.itemsLoaded;

  //   if (item.description && item.description.toLowerCase().includes('sul')) {
  //     item.Transportadora = 'TCM';
  //   }

  //   if (item.description && item.description.toLowerCase().includes('prog')) {
  //     item.Transportadora = 'JSL';
  //   }
  //   this.Transportadoras = item.Transportadora;
  //   this.listaTransportadoras = [this.Transportadoras, ...this.transportadora];

  //   this.fornecedores1 = this.fornecedores.map(fornecedor => fornecedor.local);
  //   this.fornecedores2 = this.fornecedores.map(fornecedor => fornecedor.local);
  //   this.fornecedores3 = this.fornecedores.map(fornecedor => fornecedor.local);
  //   this.fornecedores4 = this.fornecedores.map(fornecedor => fornecedor.local);

  //   this.listaVeiculo1 = this.tipoVeiculo.map(item => item.modelo);
  //   this.listaVeiculo1 = [item['Transport Type'], ...this.listaVeiculo1];

  //   this.item['Transport Type'] = item['Transport Type'];

  //   this.fornecedoresDescarga1 = this.fornecedores
  //     .filter(fornecedor => fornecedor.descarga === true)
  //     .map(fornecedor => fornecedor.local);
  //   this.fornecedoresDescarga2 = this.fornecedores
  //     .filter(fornecedor => fornecedor.descarga === true)
  //     .map(fornecedor => fornecedor.local);
  //   this.fornecedoresDescarga3 = this.fornecedores
  //     .filter(fornecedor => fornecedor.descarga === true)
  //     .map(fornecedor => fornecedor.local);
  //   this.fornecedoresDescarga4 = this.fornecedores
  //     .filter(fornecedor => fornecedor.descarga === true)
  //     .map(fornecedor => fornecedor.local);
  // }

  addViagem(item: any): void {
    this.item = { ...item };
    // console.log(this.item)
    const dataHoraString1 = item['Janela 1'];
    const dataHoraString2 = item['Janela 2'];
    const dataHoraString3 = item['Janela 3'];
    const dataHoraString4 = item['Janela 4'];
    const dataHoraStringDestino1 = item['JanelaDestino 1'];
    const dataHoraStringDestino2 = item['JanelaDestino 2'];
    const dataHoraStringDestino3 = item['JanelaDestino 3'];
    const dataHoraStringDestino4 = item['JanelaDestino 4'];
    // Extrair a data e a hora da string
    if (dataHoraString1) {
      this.item.dataJanela1 = dataHoraString1.slice(0, 10); // "2024-04-23"
      this.item.horaJanela1 = dataHoraString1.slice(11, 16); // "00:00"
    }
    if (dataHoraString2) {
      this.item.dataJanela2 = dataHoraString2.slice(0, 10); // "2024-04-23"
      this.item.horaJanela2 = dataHoraString2.slice(11, 16); // "00:00"
    }
    if (dataHoraString3) {
      this.item.dataJanela3 = dataHoraString3.slice(0, 10); // "2024-04-23"
      this.item.horaJanela3 = dataHoraString3.slice(11, 16); // "00:00"
    }
    if (dataHoraString4) {
      this.item.dataJanela4 = dataHoraString4.slice(0, 10); // "2024-04-23"
      this.item.horaJanela4 = dataHoraString4.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino1) {
      this.item.dataJanelaDestino1 = dataHoraStringDestino1.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino1 = dataHoraStringDestino1.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino2) {
      this.item.dataJanelaDestino2 = dataHoraStringDestino2.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino2 = dataHoraStringDestino2.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino3) {
      this.item.dataJanelaDestino3 = dataHoraStringDestino3.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino3 = dataHoraStringDestino3.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino4) {
      this.item.dataJanelaDestino4 = dataHoraStringDestino4.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino4 = dataHoraStringDestino4.slice(11, 16); // "00:00"
    }
    if (Array.isArray(this.carriers)) {
      this.transportadora = this.carriers.map(carrier => carrier.name);
    }
    if (Array.isArray(this.places)) {
      this.locais = this.places.map(places => places.local);
    }
    if (item.description !== undefined && item.description !== '' && item.description !== null) {
      this.progManual.push(item.description);
    }
    // if (item.description && item.description.toLowerCase().includes('TCM')) {
    //   item.Transportadora = 'TCM';
    // }
    // if (item.description && item.description.toLowerCase().includes('JSL')) {
    //   item.Transportadora = 'JSL';
    // }
    if (item.description && item.description.toLowerCase().includes('TCM VW')) {
      item.Transportadora = 'TCM VW';
    }
    if (item.description && item.description.toLowerCase().includes('JSL VW')) {
      item.Transportadora = 'JSL VW';
    }
    if (item.description && item.description.toLowerCase().includes('SESE VW')) {
      item.Transportadora = 'SESE VW';
    }
    this.Transportadoras = item.Transportadora;
    this.listaTransportadoras = [this.Transportadoras, ...this.transportadora];
    this.fornecedores1 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores2 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores3 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores4 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.listaVeiculo1 = this.tipoVeiculo.map(item => item.modelo);
    this.listaVeiculo1 = [item['Transport Type'], ...this.listaVeiculo1];
    this.fornecedoresDescarga1 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga2 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga3 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga4 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.dialogAddViagem = true;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }

  }

  async salvar2(item: any) {
    this.isLoading = true;
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      this.item.ID = formattedDate.toString();
    }
    this.item = { ...item };
    // console.log(item)
    // console.log(this.item)
    if (this.item.dataJanela1 && this.item.horaJanela1) {
      const dataHoraStringRefeitaJanela1 = `${this.item.dataJanela1}T${this.item.horaJanela1}:00.000Z`;
      const dataHoraJanela1 = new Date(dataHoraStringRefeitaJanela1);
      this.item['Janela 1'] = dataHoraJanela1.toISOString();
    }
    if (this.item.dataJanela2 && this.item.horaJanela2) {
      const dataHoraStringRefeitaJanela2 = `${this.item.dataJanela2}T${this.item.horaJanela2}:00.000Z`;
      const dataHoraJanela2 = new Date(dataHoraStringRefeitaJanela2);
      this.item['Janela 2'] = dataHoraJanela2.toISOString();
    }
    if (this.item.dataJanela3 && this.item.horaJanela3) {
      const dataHoraStringRefeitaJanela3 = `${this.item.dataJanela3}T${this.item.horaJanela3}:00.000Z`;
      const dataHoraJanela3 = new Date(dataHoraStringRefeitaJanela3);
      this.item['Janela 3'] = dataHoraJanela3.toISOString();
    }
    if (this.item.dataJanela4 && this.item.horaJanela4) {
      const dataHoraStringRefeitaJanela4 = `${this.item.dataJanela4}T${this.item.horaJanela4}:00.000Z`;
      const dataHoraJanela4 = new Date(dataHoraStringRefeitaJanela4);
      this.item['Janela 4'] = dataHoraJanela4.toISOString();
    }
    if (this.item.dataJanelaDestino1 && this.item.horaJanelaDestino1) {
      const dataHoraStringRefeita1 = `${this.item.dataJanelaDestino1}T${this.item.horaJanelaDestino1}:00.000Z`;
      const dataHora1 = new Date(dataHoraStringRefeita1);
      this.item['JanelaDestino 1'] = dataHora1.toISOString();
    }

    if (this.item.dataJanelaDestino2 && this.item.horaJanelaDestino2) {
      const dataHoraStringRefeita2 = `${this.item.dataJanelaDestino2}T${this.item.horaJanelaDestino2}:00.000Z`;
      const dataHora2 = new Date(dataHoraStringRefeita2);
      this.item['JanelaDestino 2'] = dataHora2.toISOString();
    }

    if (this.item.dataJanelaDestino3 && this.item.horaJanelaDestino3) {
      const dataHoraStringRefeita3 = `${this.item.dataJanelaDestino3}T${this.item.horaJanelaDestino3}:00.000Z`;
      const dataHora3 = new Date(dataHoraStringRefeita3);
      this.item['JanelaDestino 3'] = dataHora3.toISOString();
    }

    if (this.item.dataJanelaDestino4 && this.item.horaJanelaDestino4) {
      const dataHoraStringRefeita4 = `${this.item.dataJanelaDestino4}T${this.item.horaJanelaDestino4}:00.000Z`;
      const dataHora4 = new Date(dataHoraStringRefeita4);
      this.item['JanelaDestino 4'] = dataHora4.toISOString();
    }
    this.item.Passos = 0;
    if (this.item['Fornecedor 1'] !== '' && this.item['Fornecedor 1'] !== null && this.item['Fornecedor 1'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 2'] !== '' && this.item['Fornecedor 2'] !== null && this.item['Fornecedor 2'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 3'] !== '' && this.item['Fornecedor 3'] !== null && this.item['Fornecedor 3'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 4'] !== '' && this.item['Fornecedor 4'] !== null && this.item['Fornecedor 4'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }

    if (this.item['Destino 1'] !== '' && this.item['Destino 1'] !== null && this.item['Destino 1'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 2'] !== '' && this.item['Destino 2'] !== null && this.item['Destino 2'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 3'] !== '' && this.item['Destino 3'] !== null && this.item['Destino 3'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 4'] !== '' && this.item['Destino 4'] !== null && this.item['Destino 4'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    this.item.tableName = this.query
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    //console.log(jsonArray)
    await this.dynamoDBService.salvar(jsonArray, this.query, this.urlSalva).subscribe(async response => {
      await this.update();
      this.isLoading = false;
      this.dialogAddViagem = false;
    }, error => {
      console.log(error);
    });
  }

  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  filtra() {
    //console.log("entrou em filtra")

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 1']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado1 = true;
      } else {
        item.cadastrado1 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 2']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado2 = true;
      } else {
        item.cadastrado2 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 3']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado3 = true;
      } else {
        item.cadastrado3 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 4']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado4 = true;
      } else {
        item.cadastrado4 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 1']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino1 = true;
      } else {
        item.cadastradoDestino1 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 2']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino2 = true;
      } else {
        item.cadastradoDestino2 = false;
      }
    }


    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 3']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino3 = true;
      } else {
        item.cadastradoDestino3 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 4']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino4 = true;
      } else {
        item.cadastradoDestino4 = false;
      }
    }
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }


  getFornecedorKeyByIndex(item: any, index: number): string {
    const fornecedorKeys = this.getKeysByPrefix(item, 'Fornecedor');
    return fornecedorKeys[index - 1];
  }

  getDestinoKeyByIndex(item: any, index: number): string {
    const destinoKeys = this.getKeysByPrefix(item, 'Destino');
    return destinoKeys[index - 1];
  }

  getKeysByPrefix(obj: any, prefix: string): string[] {
    return Object.keys(obj).filter(key => key.startsWith(prefix));
  }

  ngOnDestroy() {
    this.searchTextSubscription?.unsubscribe();
  }

  converterData(stringData: string): string {
    const partes = stringData.split('/');
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];

    return `${ano}-${mes}-${dia}`;
  }

  aplicarFiltroPorData(): void {
    if (this.filtroDataInicio && this.filtroDataTermino) {
      const filtroInicio = new Date(this.filtroDataInicio);
      const filtroTermino = new Date(this.filtroDataTermino);

      this.itemsFiltrados = this.items.filter(item => {
        const dataFormatada = this.converterData(item.ATA);
        const dataItem = new Date(dataFormatada);

        return dataItem >= filtroInicio && dataItem <= filtroTermino;
      });
    } else {
      this.itemsFiltrados = this.items;
    }
  }

  formatDate(dateString: string) {
    const [day, month, year] = dateString.split('/'); // Divide a string em partes
    return `${year}-${month}-${day}`; // Formata no formato yyyy-MM-dd
  }

  async getItemsFromDynamoDB(): Promise<void> {
    //console.log("entrou em getItemsFromDynamoDB")
    let janela1Date: any;
    let janela1Hora: any;
    let janelaDestino1Date: any;
    let janelaDestino1Hora: any;
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query, this.urlConsultaTrips, 'SESE')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = await JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.items = items
              .filter(item => item.description && (item.description.includes('SESE') || item.description.toLowerCase().includes('sese')))
              .filter(item => item.Finalizada != "True" && item.Finalizada != "true" && item.Finalizada != true) // Novo filtro adicionado     
            this.items = this.items
              .filter((item: { FinalizadaManual: boolean; }) => item.FinalizadaManual != true)
              .map((item: { [x: string]: any; date: string | number | Date; }) => {              
                return {
                  ...item,            
                  classZap: 'laranja-icon',
                  icone: 'zap'
                };
              });
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  verificaConexaoJanela() {
    // Obtém a data atual
    const dataAtual = new Date();
    // Subtrai uma hora (3600 segundos * 1000 milissegundos)
    const umaHoraAtras = new Date(dataAtual.getTime() - 3600 * 1000);

    this.items.forEach(item => {
      // Converte o valor de item['Janela 1'] para um objeto Date
      const dataJanela1 = new Date(item['Janela 1']);
      // Compara dataJanela1 com umaHoraAtras e verifica se Conexao não é verdadeiro
      if (dataJanela1 > umaHoraAtras && item['Conexao'] !== true) {
        item['classZap'] = "laranja-icon";
        item['icone'] = "zap-off";
      }
      else if (dataJanela1 > umaHoraAtras && item['Conexao'] == true) {
        item['classZap'] = "green-icon";
        item['icone'] = "zap";
      }
      else if (dataJanela1 < umaHoraAtras && item['Conexao'] !== true) {
        item['classZap'] = "vermelho-icon";
        item['icone'] = "zap-off";
      }
      else if (dataJanela1 < umaHoraAtras && item['Conexao'] == true) {
        item['classZap'] = "blinking-icon";
        item['icone'] = "zap";
      }

    });
  }


  async getFornecedoresFromDynamoDB(): Promise<void> {
    //console.log("entrou em getFornecedoresFromDynamoDB")

    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query3, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.fornecedores = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            this.fornecedores = this.fornecedores.sort((a, b) => a.local.localeCompare(b.local));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPosicaoFromDynamoDB(): Promise<void> {
    // //console.log("entrou em getPosicaoFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.posicao = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    //console.log("entrou em getCarriersFromDynamoDB")

    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query4, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.carriers = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  async getTipoVeiculoFromDynamoDB(): Promise<void> {
    //console.log("entrou em getTipoVeiculoFromDynamoDB")

    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query5, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.tipoVeiculo = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  armazenarLatitudeEmItems() {
    // //console.log("entrou em armazenarLatitudeEmItems")

    for (let i = 0; i < this.items.length; i++) {
      const plate = this.items[i]['Plate'];
      const matchingPosicao = this.posicao.find(obj => obj['ID'] === plate);
      if (matchingPosicao) {
        this.items[i]['Latitude'] = matchingPosicao['Latitude'];
        this.items[i]['Longitude'] = matchingPosicao['Longitude'];
        this.items[i]['Endereco'] = matchingPosicao['Endereco'];
        this.items[i]['data_atualizacao'] = new Date(matchingPosicao['data_atualizacao']);
        this.items[i]['DataBordo'] = new Date(matchingPosicao['DataBordo']);

      }
      if (this.items[i]['DataBordo'] === undefined) {
        this.items[i]['Conexao'] = false;
      } else {
        this.DataAtual = new Date();
        var outraData = new Date(this.items[i]['DataBordo']);
        // //console.log(this.DataAtual)
        // //console.log(outraData)
        // //console.log(new Date(outraData.setHours(outraData.getHours() + 1)))


        if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
          this.items[i]['Conexao'] = true;
        } else {
          this.items[i]['Conexao'] = false;
        }
      }

    }
  }


  async salvarFornecedor() {
    this.isLoading = true;
    if (this.item.ID === undefined || this.item.ID === '') {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);

      this.item = {
        "ID": formattedDate.toString(),
        "contato": this.item.contato,
        "endereco": this.item.endereco,
        "local": this.item.local,
        "latitude": this.item.latitude,
        "longitude": this.item.longitude,
        "descarga": this.item.descarga,
        "nomeContato": this.item.nomeContato,
        "telefone": this.item.telefone
      }
    }

    this.item.tableName = this.query3
    //console.log(this.item)

    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string


    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };

    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);

    //console.log(modifiedJsonString);

    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };

    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    //console.log(jsonArray)
    await this.dynamoDBService.salvar(jsonArray, this.query3, this.urlSalva).subscribe(async response => {
      await this.update();
      this.isLoading = false;

    }, error => {
      console.log(error);
    });
    this.dialogOpen = false;
    // setTimeout(() => {
    //   this.getItemsFromDynamoDB();
    // }, 200);
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
  }

  editDialog(item: any): void {
    //console.log(item)
    this.item.ID = item.ID
    this.item.local = item;
    this.item.contato = item.contato;
    this.item.endereco = item.endereco;
    this.item.latitude = item.latitude;
    this.item.longitude = item.longitude;
    this.item.descarga = item.descarga;
    this.nomeContato = item.nomeContato;
    this.telefone = item.telefone;
    this.dialogOpen = true;
  }

  async completaViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      //console.log(item)
      var PassoF: any = []
      var PassoD: any = []
      for (let i = 1; i < 5; i++) {
        if (item['Fornecedor ' + i]) {
          PassoF[i] = 2;
        } else {
          PassoF[i] = 0;
        }
        // //console.log('PassoF[' + i + '] = ' + PassoF[i])
      }
      for (let i = 1; i < 5; i++) {
        if (item['Destino ' + i]) {
          PassoD[i] = 2;
        } else {
          PassoD[i] = 0;
        }
        // //console.log('PassoD[' + i + '] = ' + PassoD[i])
      }
      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "Finalizada": true,
        'Passo Fornecedor1': PassoF[1],
        'Passo Fornecedor2': PassoF[2],
        'Passo Fornecedor3': PassoF[3],
        'Passo Fornecedor4': PassoF[4],
        'Passo Destino1': PassoD[1],
        'Passo Destino2': PassoD[2],
        'Passo Destino3': PassoD[3],
        'Passo Destino4': PassoD[4],
      }];
      //nao usa a query, ele manda a time table no item
      await this.dynamoDBService.salvar(body, this.query2, this.urlSalva).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }


  acaoDeClique(item: any, NomePasso: string, NomeBotao: string, NomeDestino: string) {
    if (item[NomeBotao] === false) {
      // Executa ação 1
      //console.log(item)
      this.editDialog(item[NomeDestino]);
    } else {
      // Executa ação 2
      this.finalizaPasso(NomePasso, item);
    }
  }

  async finalizaPasso(Passo: string, item: any) {
    // Exibe a caixa de diálogo de confirmação
    const confirmacao = window.confirm("Tem certeza que deseja confirmar a coleta neste ponto?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.salvar(Passo, item);

      // Adicione aqui qualquer outra lógica que você deseja executar após salvar o item
    }

  }

  async salvar(Passo: String, item: any): Promise<void> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = [];
    if (Passo == 'Placa') {
      body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "Plate": item.Plate,
      }];
    } else {
      let ValorPasso = 0;
      let ContadorPasso = 0;
      switch (Passo) {
        case 'Passo Fornecedor1':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 1'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor2':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 2'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor3':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 3'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor4':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 4'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino1':
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 1'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino2':
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 2'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino3':
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 3'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino4':
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 4'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
      }


      if (item['Passo Fornecedor1'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor2'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor3'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor4'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino1'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino2'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino3'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino4'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (parseInt(item['Passos'], 10) === ContadorPasso) {
        body = [{
          ...item, // Mantém as chaves existentes
          "ID": item.ID,
          "Finalizada": true,
          [Passo.toString()]: ValorPasso,
          // Adicione outros campos conforme necessário
        }];
      } else {
        body = [{
          ...item, // Mantém as chaves existentes
          "ID": item.ID,
          [Passo.toString()]: ValorPasso,
          // Adicione outros campos conforme necessário
        }];
      }
    }
    await this.dynamoDBService.salvar(body, this.query2, this.urlSalva).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // //console.log(response)
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
  }

  getItemAntigo(item: any): number {
    for (let i = 0; i < this.itemsAntigo.length; i++) {
      if (this.itemsAntigo[i].ID === item.ID) {
        return i;
      }
    }
    return -1; // Retorna -1 se não encontrar correspondência
  }
}





